module.exports = __webpack_public_path__ + "img/wechat-tabs3.cfccba8a.png";